function StatCounter({ value, label }) {
  return (
    <div className="text-center">
      <p className="font-display font-black text-3xl md:text-4xl text-white">{value.toLocaleString()}+</p>
      <p className="text-xs uppercase tracking-wide text-zinc-400 mt-1">{label}</p>
    </div>
  );
}

export default function StatsStrip({ stats }) {
  return (
    <section className="bg-zinc-950 py-8 border-b border-white/10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
        <StatCounter value={stats.scenarios_count} label="Scenarios Documented" />
        <StatCounter value={stats.votes_count} label="Community Votes Cast" />
        <StatCounter value={stats.incidents_count} label="Incidents Reported" />
        <StatCounter value={stats.subscribers_count} label="People in the Movement" />
      </div>
    </section>
  );
}
